import { DataFilter } from '@siclop/kstone-vue'

export class ProfessionFilter extends DataFilter {
  code?: string
  label?: string

  constructor(data?: Partial<ProfessionFilter>) {
    super(data)
    if (data) {
      this.code = data.code
      this.label = data.label
    }
  }
}
